import { useMemo, useState } from 'react';

// `placeholder` exists for the compact single-row forms (the To Order add
// bar), where the field has no label above it to say what it's for.
export default function VendorAutocomplete({
  value,
  onChange,
  vendors,
  onCreateVendor,
  placeholder,
}) {
  const [open, setOpen] = useState(false);
  const [creating, setCreating] = useState(false);

  const query = value.trim().toLowerCase();
  const filtered = useMemo(
    () => vendors.filter((v) => v.name.toLowerCase().includes(query)),
    [vendors, query]
  );
  const exactMatch = vendors.some((v) => v.name.toLowerCase() === query);

  const selectVendor = (name) => {
    onChange(name);
    setOpen(false);
  };

  const createVendor = async () => {
    setCreating(true);
    try {
      const vendor = await onCreateVendor(value.trim());
      selectVendor(vendor.name);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="vendor-autocomplete">
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        autoComplete="off"
      />
      {open && (filtered.length > 0 || (value.trim() && !exactMatch)) && (
        <ul className="vendor-autocomplete-list">
          {filtered.map((v) => (
            <li key={v.id}>
              <button type="button" onClick={() => selectVendor(v.name)}>
                {v.name}
              </button>
            </li>
          ))}
          {value.trim() && !exactMatch && (
            <li>
              <button type="button" disabled={creating} onClick={createVendor}>
                + Add "{value.trim()}" as new vendor
              </button>
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
